<template>
  <div>
    <h1>AHMET</h1>
  </div>
</template>

<script>
export default { name: 'Ahmet' }
</script>

<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Ahmet.vue